export default __webpack_public_path__ + "static/media/bg-college-login.724d4ef3.webp";